import React from "react"
import { SortableTh } from "../../components/SortableColumns"
import { DetailLink } from "../../components/Table/DetailLink"
import { GenericOverview } from "../../components/Table/GenericOverview"
import { Link, useNavigate } from "react-router-dom"
import { Col, Row } from "react-bootstrap"
import { formatDateTime } from "../../util/formatDataTime"
import { MapTenantToTenantName } from "./UserAdd"
import { RoleProtect } from "../../components/Authorization/RoleProtect"
import { Permission } from "../../api"

export const UserOverview = () => {
    const endpoint = "/v2/consumer/users"

    const jsonDataField = (setData, data) => setData(data.users)
    const navigate = useNavigate()

    const filter = {
        initial: "",
        onSearch: (_, searchText) => searchText,
    }

    const error = {
        title: "Failed to get users",
        body: "Something went wrong while getting the users, see the console for more details.",
    }

    const table = {
        header: [
            <SortableTh column="email">Email</SortableTh>,
            <th>Tenant</th>,
            <SortableTh column="Role.name">Role</SortableTh>,
            <SortableTh column="last_auth">Last activity</SortableTh>,
            <th>Actions</th>,
        ],
        body: (value) => {
            // Role is rolename (+countallowed) (-countdenied), if countallowed and countdenied are both 0, only show rolename
            const roleString =
                value.role_properties.name +
                (value.allowed_permissions.length > 0
                    ? ` (+${value.allowed_permissions.length})`
                    : "") +
                (value.denied_permissions.length > 0
                    ? ` (-${value.denied_permissions.length})`
                    : "")

            return (
                <tr
                    key={value.id}
                    onClick={() => {
                        navigate(`/user/${value.id}`)
                    }}
                >
                    <td>{value.email}</td>
                    <td>{MapTenantToTenantName(value.tenant)}</td>
                    <td>{roleString}</td>
                    <td>{formatDateTime(value.last_auth)}</td>
                    <td>
                        <DetailLink to={`/user/${value.id}`} />
                    </td>
                </tr>
            )
        },
    }

    return (
        <Row className="content-section">
            <Col>
                <h2 className="float-start">Users</h2>
                <RoleProtect allowedPermissions={[Permission.SetAnyResourceUser]}>
                    <Link className="btn btn-success float-end mb-3" to="/user/add">
                        Add user
                    </Link>
                </RoleProtect>
                <GenericOverview
                    apiEndpoint={endpoint}
                    dataField={jsonDataField}
                    filter={filter}
                    error={error}
                    table={table}
                />
            </Col>
        </Row>
    )
}
